import { useContext } from 'react';

import { DeleteGoalContext } from './delete-goal-context';

export const useOpenDeleteGoalDialog = () => {
  const { onDeleteGoal } = useContext(DeleteGoalContext);

  return onDeleteGoal;
};
